import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { playNotificationSound } from "../../utils";
import { notificationMessage } from "../../utils/toastMessage/toastMessage";

const NotificationListener = () => {
  const socket = useSelector((state) => state.socket);

  const showNotification = (item) => {
    const title = item.title;
    const text = item.description;
    playNotificationSound(item.type);

    notificationMessage(title, text, item.type, item.isAutoClose, item.url);
  };

  useEffect(() => {
    if (!isEmpty(socket)) {
      socket.on("new-alert", showNotification);

      return () => {
        socket.off("new-alert", showNotification);
      };
    }
  }, [socket]);

  return null;
};

export default NotificationListener;
